class HelpSuite extends HTMLElement {
  constructor() {
    super();

    this.tabs = Array.from(this.querySelectorAll('[data-help-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-help-panel]'));
    this.toggleButtons = Array.from(this.querySelectorAll('[data-help-support-toggle]'));
    this.supportViews = Array.from(this.querySelectorAll('[data-help-support-view]'));

    this.onTabClick = this.onTabClick.bind(this);
    this.onSupportToggleClick = this.onSupportToggleClick.bind(this);
  }

  connectedCallback() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick);
    });

    this.toggleButtons.forEach((button) => {
      button.addEventListener('click', this.onSupportToggleClick);
    });

    if (this.tabs.length > 0) {
      const activeTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.activateTab(activeTab.dataset.helpTab);
    }

    if (this.toggleButtons.length > 0) {
      const activeToggle = this.toggleButtons.find((button) => button.classList.contains('is-active')) || this.toggleButtons[0];
      this.activateSupportView(activeToggle.dataset.helpSupportToggle);
    }
  }

  disconnectedCallback() {
    this.tabs.forEach((tab) => {
      tab.removeEventListener('click', this.onTabClick);
    });

    this.toggleButtons.forEach((button) => {
      button.removeEventListener('click', this.onSupportToggleClick);
    });
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    this.activateTab(tab.dataset.helpTab);
  }

  onSupportToggleClick(event) {
    const button = event.currentTarget;
    this.activateSupportView(button.dataset.helpSupportToggle);
  }

  activateTab(key) {
    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.helpTab === key;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.helpPanel === key;
      panel.hidden = !isActive;
    });
  }

  activateSupportView(key) {
    this.toggleButtons.forEach((button) => {
      const isActive = button.dataset.helpSupportToggle === key;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    this.supportViews.forEach((view) => {
      view.hidden = view.dataset.helpSupportView !== key;
    });
  }
}

if (!customElements.get('help-suite')) {
  customElements.define('help-suite', HelpSuite);
}
